import {
  faFacebook,
  faInstagram,
  faLinkedin,
  faWhatsapp,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faCopy } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";
import "./style.css";

const ShareModal = ({
  show,
  onHide,
  t,
  shareWhatsapp,
  shareInstagram,
  shareFacebook,
  shareLinkedIn,
  shareTwitter,
  handleCopyShareLink,
  themeVars,
}) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="instructor-share-modal"
      dialogClassName="share-modal"
      style={themeVars}
    >
      <Modal.Header closeButton closeButtonClassName="auto-theme-text">
        <Modal.Title className="auto-theme-text">{t("sharePost")}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <div className="share-modal-subtitle">{t("sharePostSubtitle")}</div>

        <div className="share-options">
          <button className="share-card whatsapp" onClick={shareWhatsapp}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faWhatsapp} />
            </div>
            <span>{t("whatsapp")}</span>
          </button>

          <button className="share-card facebook" onClick={shareFacebook}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faFacebook} />
            </div>
            <span>{t("facebook")}</span>
          </button>

          <button className="share-card instagram" onClick={shareInstagram}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faInstagram} />
            </div>
            <span>{t("instagram")}</span>
          </button>

          <button className="share-card linkedin" onClick={shareLinkedIn}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faLinkedin} />
            </div>
            <span>{t("linkedin")}</span>
          </button>

          <button className="share-card twitter" onClick={shareTwitter}>
            <div className="share-icon">
              <FontAwesomeIcon icon={faXTwitter} />
            </div>
            <span>{t("twitter")}</span>
          </button>
        </div>

        <button className="site-btn w-100 mt-3" onClick={handleCopyShareLink}>
          <FontAwesomeIcon icon={faCopy} /> <span>{t("copyText")}</span>
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default ShareModal;
